import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const permissionKey = 'Permission-Token'
const Captoken = 'CAPTCHA_TOKEN'
export function getToken () {
  return Cookies.get(TokenKey)
}
export function getCaptoken () {
  return Cookies.get(Captoken)
}
export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}
export function getPermissionToken () {
  return Cookies.get(permissionKey)
}
export function setPermissionToken (token) {
  return Cookies.set(permissionKey, token)
}
export function removePermissionToken (token) {
  return Cookies.remove(permissionKey)
}
// compare view data
export const setCompareData = (page, params) => {
  return localStorage.setItem(page, params)
}
export const getCompareData = (page) => {
  console.log(page)
  return localStorage.getItem(page)
}
export const removeCompareData = (page) => {
  return localStorage.removeItem(page)
}



// WEBPACK FOOTER //
// ./src/utils/token.js